import gql from 'graphql-tag';

export const GET_CLOSE_REASONS = gql`
  query GetCloseReasonsForTemplate($id: ID!) {
    bpf {
      result: closeReasons(id: $id) {
        error
        success
        list {
          id
          type
          label
          flowId
          isActive
          createdDateTime
          modifiedDateTime
        }
      }
    }
  }
`;
